import { LOCATION_CHANGE } from 'connected-react-router';

import breakPoints from 'app/styles/constants/breakpoints';
import {
  pageNameFromRouterPath,
  pageTitleFromRouterPath,
  referrer,
} from 'app/router/selectors';
import { isUserAuthenticated } from 'app/features/user/selectors';

const page = {
  [LOCATION_CHANGE]: (getState, { payload }) => {
    const state = getState();

    const mediaQuery = `(${breakPoints.widthXSmallExtended})`;
    const isMinXSmallExtended = window.matchMedia(mediaQuery).matches;

    return {
      type: 'page',
      name: pageNameFromRouterPath(state),
      properties: {
        isAuthenticated: isUserAuthenticated(state),
        url: window.location.href,
        path: payload.location.pathname,
        referrer: referrer(state),
        mobileLayout: !isMinXSmallExtended,
        title: pageTitleFromRouterPath(state),
      },
    };
  },
};

export default page;
